import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";
import { ref } from "vue";

export async function updateBridge(bridgeData) {
  const axios = axiosInstance().primoLab;
  let bridge = ref([]);

  await axios
    .put("/prescription-rows", {
      ids: bridgeData,
    })
    .then(async (response) => {
      bridge.value = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { bridge };
}
